import { render, staticRenderFns } from "./markAsCompletedModal.vue?vue&type=template&id=227596ab&scoped=true&"
import script from "./markAsCompletedModal.vue?vue&type=script&lang=js&"
export * from "./markAsCompletedModal.vue?vue&type=script&lang=js&"
import style0 from "./markAsCompletedModal.vue?vue&type=style&index=0&id=227596ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227596ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227596ab')) {
      api.createRecord('227596ab', component.options)
    } else {
      api.reload('227596ab', component.options)
    }
    module.hot.accept("./markAsCompletedModal.vue?vue&type=template&id=227596ab&scoped=true&", function () {
      api.rerender('227596ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workspace/markAsCompletedModal.vue"
export default component.exports